export const getGroupedByStatus = (listItemsDisable) => {
    const grouped = {}
    listItemsDisable.forEach(item => {
        if (!grouped[item.production_status]) grouped[item.production_status] = []
        grouped[item.production_status].push(item)
    })
    return grouped
}